export const typeDisplayLabels = {
  text: 'Short Answer',
  textarea: 'Long Answer',
  number: 'Number Field',
  dropdown: 'Dropdown',
  multi_select: 'Multi-Select Dropdown',
  checkbox: 'Checkbox',
  date: 'Date',
  birthdate: 'Birth Date',
  phone: 'Phone',
  email: 'Email',
  url: 'URL',
  country: 'Country',
  player_position: 'Player Position',
  hockey_usa: 'USA Hockey',
  // Hidden from the question-type picker for now — Hockey Canada validation is
  // handled API-side, so admins don't add it as a question type. The type is
  // still supported everywhere else; uncomment to offer it again.
  // hockey_canada: 'Hockey Canada Player Number',
  player_number: 'Player Number',
  relationship: 'Player Relationship',
  teamOfficialRole: 'Team Official Role',
} as const

export type QuestionType = keyof typeof typeDisplayLabels
